"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEOPhaseDurationInMinutes = getEOPhaseDurationInMinutes;
const constants_1 = require("@daytrip/constants");
function getEOPhaseDurationInMinutes(daysToDeparture) {
    if (daysToDeparture < constants_1.LAST_MINUTE_ORDER_THRESHOLD_IN_DAYS) {
        return 0;
    }
    if (daysToDeparture < 3) {
        return 30;
    }
    if (daysToDeparture < constants_1.POST_OFFERS_AT_DRIVING_HOURS_DAYS_TRESHOLD) {
        return constants_1.HOUR_IN_MINUTES * 2;
    }
    // In practice for trips 6+ days to departure, trip will be in EO
    // until 6PM current day for departure 6-14 days away (4h EO window from 2PM)
    // until next day at 6pm for departure 14-23 days away
    // until 6pm 2 days later for departure 23+ days away
    // (see getOfferPostingTime)
    if (daysToDeparture > 23) {
        return constants_1.HOUR_IN_MINUTES * 48;
    }
    if (daysToDeparture > 14) {
        return constants_1.HOUR_IN_MINUTES * 24;
    }
    return constants_1.HOUR_IN_MINUTES * 4;
}
//# sourceMappingURL=getEOPhaseDurationInMinutes.js.map